<template>
    <!-- <div class="main-content blue-bg"> -->
      <div class="title">
        <h3>专家团队</h3>
        <p class="small-text">Expert team</p>
      </div>
      <div class="container team-list">
        <div v-for="(item, index) in teamList" :key="index" class="team-item" :class="item.bgColor">
          <img :src="item.avatar" alt="" class="team-avatar" />
           <p class="team-position">{{item.position}}</p>
           <p class="team-name">{{item.name}}</p>
           <p v-for="(citem, index) in item.description.split('|')" :key="index" class="team-content">{{citem}}</p>
        </div>
      </div>
    <!-- </div> -->
</template>
<script setup lang="ts">
import { ref } from 'vue'
import team01 from '@/assets/images/team/img01.png'
import team02 from '@/assets/images/team/img02.png'
import team03 from '@/assets/images/team/img03.png'

const teamList = ref([
  {
    name: '殷建文',
    position: '大数据人工智能专家',
    avatar: team01,
    description: 'IBM专利主席|Texas A&M University 计算机博士|拥有27项美国专利，其中20项已授权|2021年瀚易特正式聘任殷建文博士|为AI项目研发负责人',
    bgColor: 'blue'
  },
  {
    name: '芮彩琴',
    position: '心理专家',
    avatar: team02,
    description: '哈佛专注力实践专家|国家高级心理督导师|家庭教育畅销书作家|《让孩子受益一生的专注力训练》|为平台心理健康模块提开发专家',
    bgColor: 'pink'
  },
  {
    name: '邰启扬',
    position: '心理专家',
    avatar: team03,
    description: '扬州大学教育科学学院副教授|应用心理学专业硕士生导师|心理学畅销书作家|《催眠术：一种神奇的心理疗法》|为平台心理健康模块开发专家',
    bgColor: 'purple'
  }
])
</script>
<style lang="scss" scoped>
// .main-content {
//   padding: 30px 0;
  .title {
    text-align: center;
    margin-bottom: 20px;
    .small-text {
      font-size: 12px;
      color: rgba($color: #000000, $alpha: 0.3);
      text-transform: uppercase;
    }
  }
// }
.team-list {
  display: flex;
  justify-content: space-between;
  margin-top: 150px;

  .team-item {
    width: 360px;
    height: 320px;
    position: relative;
    padding: 80px 30px 30px;
    text-align: center;
    border-radius: 20px;
    color: #3A3F60;
    transition: all 0.3s ease-in-out;
    &.blue {
      background: #E3F1FF;
    }
    &.pink {
      background: #FFF4EC;
    }
    &.purple {
      background: #E4E9FF;
    }
    .team-position {
      font-size: 18px;
      font-weight: 500;
    }
    .team-name {
      font-size: 24px;
      font-weight: 700;
      margin: 5px 0 20px;
    }
    .team-content {
      font-size: 14px;
      font-weight: 400;
    }
    .team-avatar {
      position: absolute;
      width: 200px;
      height: 200px;
      border-radius: 50%;
      top: -42%;
      left: 50%;
      transform: translate(-50%, 0);
      transition: all 0.3s ease-in-out;
    }
    &:hover {
      .team-avatar {
        transform: translate(-50%, -10px);
        box-shadow: 0 10px 20px rgba(0,0,0,0.1);
      }
    }
  }
}
</style>